import { motion } from "framer-motion";
import { ZapCartLogo } from "@/components/ZapCartLogo";

export function Splash() {
  return (
    <motion.div data-testid="splash-screen" className="fixed inset-0 z-[999] flex flex-col items-center justify-center"
      style={{ background: "linear-gradient(135deg,#0B2A5B 0%,#1E3A8A 100%)" }}
      initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <motion.div initial={{ scale: 0.6, opacity: 0, y: 10 }} animate={{ scale: 1, opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 200, damping: 14 }}>
        <ZapCartLogo size={92} />
      </motion.div>
      <motion.p className="mt-5 text-3xl font-extrabold tracking-tight text-white"
        initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.25 }}>
        Zap<span style={{ color: "#34D399" }}>Basket</span>
      </motion.p>
      <motion.div className="mt-6 h-1 w-28 rounded-full bg-white/20 overflow-hidden"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.35 }}>
        <motion.div className="h-full bg-[#34D399]" initial={{ width: 0 }} animate={{ width: "100%" }} transition={{ duration: 0.6, delay: 0.15 }} />
      </motion.div>
    </motion.div>
  );
}
